export function lazyLoadImages(images = null) {
    if (!images) {
        images = document.querySelectorAll('.lazy');
    }

    const options = {
        root: null,
        rootMargin: '200px',
        threshold: 0.1,
    };

    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(handleIntersection, options);

        images.forEach(image => {
            observer.observe(image);
        });
    } else {
        for (let i = 0; i < images.length; i++) {
            if (images[i].getAttribute('data-src')) {
                images[i].setAttribute('src', images[i].getAttribute('data-src'));
                images[i].removeAttribute('data-src');

                if (images[i].getAttribute('data-height')) {
                    images[i].height = images[i].getAttribute('data-height');
                    images[i].removeAttribute('data-height');
                }

                if (images[i].getAttribute('data-width')) {
                    images[i].width = images[i].getAttribute('data-width');
                    images[i].removeAttribute('data-width');
                }
            }
        }
    }
}

function fetchImage(url) {
    return new Promise(function (resolve, reject) {
        let image = new Image();
        image.src = url;
        image.onload = resolve;
        image.onerror = reject;
    });
}

function loadImage(image) {
    const src = image.dataset.src;
    if (src) {
        fetchImage(src).then(function () {
            image.src = src;
            image.removeAttribute('data-src');

            if (image.getAttribute('data-height')) {
                image.height = image.getAttribute('data-height');
                image.removeAttribute('data-height');
            }

            if (image.getAttribute('data-width')) {
                image.width = image.getAttribute('data-width');
                image.removeAttribute('data-width');
            }
        });
    }
}

function handleIntersection(entries) {
    entries.forEach(function (entry) {
        if (entry.intersectionRatio > 0) {
            loadImage(entry.target);
        }
    });
}
